import React from 'react';

const RateHeader: React.FC = () => {
  return (
    <div className="text-center pt-8 pb-4 bg-slate-50 dark:bg-slate-900 transition-colors duration-300">
      <h1 className="text-2xl font-bold text-blue-700 dark:text-blue-400 font-myanmar mb-2 tracking-wide px-2">
        ထိုင်း မြန်မာ ငွေလဲ တွက်နည်း
      </h1>
    </div>
  );
};

export default RateHeader;